import FrontCubeData from '../../frontCubeData';

/**
 * sku根据posX分组，返回二维数组
 *
 * @param {Array} skuCubes 排完序的sku列表
 * @return {Array} 商品分组列表, 二维数组 [Array, Array]
 */
function makeSkuCubesColGroupList(skuCubes: Array<CubeId>): Array<Array<CubeId>> {
    let result: CubeId[][] = [];
    let colGroup: CubeId[] = [];

    for (let i: number = 0; i < skuCubes.length; i++) {
        let lastGroupSku: CubeId = colGroup[colGroup.length - 1];
        let lastPosX: PhysicsMeasurement = NaN;
        let curPosX: PhysicsMeasurement = FrontCubeData.getNumberValue(skuCubes[i], 'posX');

        if (lastGroupSku) {
            lastPosX = FrontCubeData.getNumberValue(lastGroupSku, 'posX');;
        }

        if (lastGroupSku && lastPosX !== curPosX) {
            result.push(colGroup);
            colGroup = [skuCubes[i]];
            continue;
        }
        colGroup.push(skuCubes[i]);
    }
    !!colGroup.length && result.push(colGroup);

    return result;
}

export {
    makeSkuCubesColGroupList
};
